import { ContractExpirationDetailReportDto } from '@client/api';
import i18n from 'i18next';

export const transformToExcelFormat = (data: ContractExpirationDetailReportDto[], selectedRows: Set<string>) => {
  const rows: Record<string, any>[] = [];
  if (data.length === 0) return [{ [i18n.t('noData', { ns: 'reporting' })]: null }];
  data.forEach((item) => {
    if (selectedRows.has(item.buildingId) || selectedRows.size === 0) {
      rows.push({
        [i18n.t('contractLength.building', { ns: 'reporting' })]: item.buildingName,
        [i18n.t('contractLength.tenants', { ns: 'reporting' })]: item.numberOfTenants,
        [i18n.t('contractLength.remainingMonths', { ns: 'reporting' })]: null,
        [i18n.t('contractLength.endDate', { ns: 'reporting' })]: null,
        [i18n.t('contractLength.contractId', { ns: 'reporting' })]: null,
      });
      item.tenants.forEach((tenant) => {
        rows.push({
          [i18n.t('contractLength.building', { ns: 'reporting' })]: null,
          [i18n.t('contractLength.tenants', { ns: 'reporting' })]: tenant.tenantName,
          [i18n.t('contractLength.remainingMonths', { ns: 'reporting' })]: tenant.remainingContractExpirationMonths,
          [i18n.t('contractLength.endDate', { ns: 'reporting' })]: tenant.expirationDate,
          [i18n.t('contractLength.contractId', { ns: 'reporting' })]: tenant.contractName,
        });
      });
    }
  });
  return rows;
};
